<template>
  <div>
    <div class="md:flex w-full justify-center">
    <div class="flex w-full">
      <FirstChapterItem v-model="story.lifeBalance.work" icon="BriefcaseIcon" :readonly="true" title="Work" class="md:mr-16 mb-2"/>
    </div>
    <div class="flex w-full">
      <FirstChapterItem v-model="story.lifeBalance.wealth" icon="DollarSignIcon" :readonly="true" title="Wealth" class="md:mr-16 mb-2"/>
    </div>
  </div>

  <div class="md:flex w-full justify-center">
    <div class="flex w-full">
      <FirstChapterItem v-model="story.lifeBalance.spirituality" icon="SunriseIcon" :readonly="true" title="Spirituality" class="md:mr-16 mb-2"/>
    </div>
    <div class="flex w-full">
      <FirstChapterItem v-model="story.lifeBalance.health" icon="ActivityIcon" :readonly="true" title="Health" class="md:mr-16 mb-2"/>
    </div>
  </div>
  <div class="md:flex w-full justify-center">
    <div class="flex w-full">
      <FirstChapterItem v-model="story.lifeBalance.growth" icon="BookIcon" :readonly="true" title="Growth" class="md:mr-16 mb-2"/>
    </div>
    <div class="flex w-full">
      <FirstChapterItem v-model="story.lifeBalance.relationships" icon="HeartIcon" :readonly="true" title="Relationships" class="md:mr-16 mb-2"/>
    </div>
  </div>

  <div class="md:flex w-full justify-center">
    <div class="flex w-full">
      <FirstChapterItem v-model="story.lifeBalance.play" icon="UsersIcon" :readonly="true" title="Play" class="md:mr-16 mb-2"/>
    </div>
    <div class="flex w-full">
      <FirstChapterItem v-model="story.lifeBalance.environment" icon="ImageIcon" :readonly="true" title="Environment" class="md:mr-16 mb-2"/>
    </div>
  </div>
  </div>

</template>

<script>
// import JourneyDay from './JourneyDay'
// import * as DateHelper from '@/helpers/date'
import _ from 'lodash'
import Story from '@/models/Story'
import FirstChapterItem from '@/views/Self-Improvee/Journey/FirstChapterItem'

export default {
  components: {
    FirstChapterItem
  },
  props: ['story'],
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
}
</script>
</style>
